
import { DashboardComponent } from './dashboard/dashboard.component';
import { PagesComponent } from './pages.component';

import { PAGES_ROUTES } from './pages.routes';
import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { DxButtonModule, DxScrollViewModule, DxDataGridModule, DxSelectBoxModule, DxCheckBoxModule, DxTemplateModule, DxPopupModule, DxChartModule, DxTreeListModule, DxNumberBoxModule, DxDateBoxModule, DxPieChartModule, DxTextBoxModule, DxTabPanelModule, DxScrollViewComponent, DxTreeViewModule, DxDropDownBoxModule, DxTreeViewComponent, DxToastModule, DxTooltipModule, DxTagBoxModule  } from 'devextreme-angular';
import { HttpClientModule } from '@angular/common/http';
import { Routes, RouterModule, CanActivate } from '@angular/router';

//import { AppComponent } from './app.component';
import { FilterPipe } from '../pipes/filter.pipe';
import { NumberFormatPipe } from '../pipes/number-format.pipe';
import { CajaComponent } from './tpv/caja/caja.component';

import { AuthGuardService as AuthGuard } from '../_guards/index';

import { LoginComponent } from '../login/index';
import { ListFormulacionComponent } from './formulacion/list-formulacion/list-formulacion.component';
import { ListTareaComponent } from './formulacion/list-tarea/list-tarea.component';
import { UnidadOrganizacionalComponent } from './parametrica/unidad-organizacional/unidad-organizacional.component';
import { FuenteComponent } from './parametrica/fuente/fuente.component';
import { OrganismoComponent } from './parametrica/organismo/organismo.component';
import { CategoriaProgramaticaComponent } from './parametrica/categoria-programatica/categoria-programatica.component';
import { ProgramaComponent } from './parametrica/programa/programa.component';
import { UnidadMedidaComponent } from './parametrica/unidad-medida/unidad-medida.component';
import { PartidaComponent } from './parametrica/partida/partida.component';
import { IntervencionComponent } from './parametrica/intervencion/intervencion.component';
import { PoaGestionComponent } from './formulacion/poa-gestion/poa-gestion.component';
import { InicioComponent } from './inicio/inicio.component';
import { OnlyNumberDirective } from '../directives/only-number.directive';
import { ListIntervencionComponent } from './formulacion/list-intervencion/list-intervencion.component';
import { FusComponent } from './ejecucion/fus/fus.component';
import { InicioEjecucionComponent } from './ejecucion/inicio-ejecucion/inicio-ejecucion.component';
import { ListFusComponent } from './ejecucion/list-fus/list-fus.component';
import { PlaFusComponent } from './ejecucion/pla-fus/pla-fus.component';
import { TraspasoDeComponent } from './traspaso/traspaso-de/traspaso-de.component';
import { TraspasoAlComponent } from './traspaso/traspaso-al/traspaso-al.component';
import { LiberacionComponent } from './traspaso/liberacion/liberacion.component';
import { AsignacionComponent } from './traspaso/asignacion/asignacion.component';
import { TraspasosAprobarComponent } from './traspaso/traspasos-aprobar/traspasos-aprobar.component';
import { TraspasosFinancieraComponent } from './traspaso/traspasos-financiera/traspasos-financiera.component';
import { TraspasosJuridicaComponent } from './traspaso/traspasos-juridica/traspasos-juridica.component';
import { AuthComponent } from './auth/auth.component';
import { ConfigGestionComponent } from './common/config-gestion/config-gestion.component';
import { FusJefaturaComponent } from './ejecucion/fus-jefatura/fus-jefatura.component';
import { PptoFusComponent } from './financiera/ppto-fus/ppto-fus.component';
import { RptGeneralComponent } from './reportes/rpt-general/rpt-general.component';
import { SegFusComponent } from './financiera/seg-fus/seg-fus.component';
import { SegFusUEComponent } from './ejecucion/seg-fus-ue/seg-fus-ue.component';
import { UserConfigComponent } from './common/user-config/user-config.component';
import { RptEjecucionFusComponent } from './financiera/rpt-ejecucion-fus/rpt-ejecucion-fus.component';
import { RptSegTraspasoComponent } from './financiera/rpt-seg-traspaso/rpt-seg-traspaso.component';
import { UsersComponent } from './common/users/users.component';
import { AuthenticationService } from '../services/guards/auth';
import { SharedModule } from '../shared/shared.module';
import { CommonModule } from '@angular/common';
import { SisinComponent } from './parametrica/sisin/sisin.component';
import { DireccionAdministrativaComponent } from './parametrica/direccion-administrativa/direccion-administrativa.component';
import { SolicitudModificacionComponent } from './solicitud/solicitud-modificacion/solicitud-modificacion.component';
import { SeguimientoInicioComponent } from './seguimiento/seguimiento-inicio/seguimiento-inicio.component';
import { SeguimientoComponent } from './seguimiento/seguimiento/seguimiento.component';
import { InicioFormulacionComponent } from './formulacion/inicio-formulacion/inicio-formulacion.component';
import { InicioInicioComponent } from './ejecucion/inicio-inicio/inicio-inicio.component';
import { ListaReportadosComponent } from './seguimiento/lista-reportados/lista-reportados.component';
import { MesActivoComponent } from './seguimiento/mes-activo/mes-activo.component';
import { ConsolidadoComponent } from './seguimiento/consolidado/consolidado.component';
import { UnidadEjecutoraSigepComponent } from './parametrica/unidad-ejecutora-sigep/unidad-ejecutora-sigep.component';
import { RevisionOperacionOdsComponent } from './revision/rev-operacion_ods/rev-operacion_ods.component';
import { RevisionAcpOdsComponent } from './revision/rev-acp_ods/rev-acp_ods.component';
import { OdsComponent } from './parametrica/ods/ods.component';
import { PsdiComponent } from './parametrica/psdi/psdi.component';
import { RevisionInicioComponent } from './revision/revision-inicio/revision-inicio.component';
import { FormulacionComponent } from './formulacion/formulacion/formulacion.component';
import { FusContabilidadComponent } from './ejecucion/fus-contabilidad/fus-contabilidad.component';
import { RolesComponent } from './common/roles/roles.component';
import { VistaComponent } from './common/vista/vista.component';
import { ManualComponent } from './ayuda/manual/manual.component';
import { AprobarSolicitudComponent } from './solicitud/aprobar-solicitud/aprobar-solicitud.component';
import { FusJueUfinComponent } from './ejecucion/fus-jue-ufin/fus-jue-ufin.component';
import { FusPagoComponent } from './ejecucion/fus-contabilidad/fus-pago.component';
import { InicioReversionComponent } from './ejecucion/inicio-reversion/inicio-reversion.component';
import { RptFormulacionComponent } from './reportes/formulacion/rpt-formulacion.component';
import { SeguimientoPdesComponent } from './pdes/seguimiento-pdes/seguimiento-pdes.component';
import { IndicadoresComponent } from './pdes/indicadores/indicadores.component';
import { SeguimientoPsdiComponent } from './psdi/seguimiento-psdi/seguimiento-psdi.component';
import { SeguimientoPeiComponent } from './pei/seguimiento-pei/seguimiento-pei.component';
import { AvisosComponent } from './notificaciones/avisos/avisos.component';
import { GruposComponent } from './notificaciones/grupos/grupos.component';
import { PacSolicitudInicioComponent } from './ejecucion/pac-solicitud/pac-solicitud-inicio.component';
import { PacSolicitudComponent } from './ejecucion/pac-solicitud/pac-solicitud.component';
import { PacSolicitudAprobarComponent } from './ejecucion/pac-solicitud/pac-solicitud-aprobar.component';
import { AprobarSolicitudJueComponent } from './solicitud/aprobar-solicitud/aprobar-solicitud-jue.component';
import { FusManualComponent } from './ejecucion/fus-manual/fus-manual.component';
import { FusInicioComponent } from './ejecucion/fus-manual/fus-inicio.component';
import { FusesComponent } from './reportes/ejecucion/fuses.component';
import { TraspasosComponent } from './reportes/formulacion/traspasos.component';
import { ModificacionFisicaComponent } from './reportes/formulacion/modificacion-fisica.component';
import { ObservacionComponent } from './parametrica/observacion/observacion.component';
import { DescripcionReporteComponent } from './parametrica/descripcion-reporte/descripcion-reporte.component';
import { PlantillasComponent } from './ayuda/plantillas/plantillas.component';
import { PermisoComponent } from './parametrica/permiso/permiso.component';
import { UserPerfilComponent } from './common/user-perfil/user-perfil.component';
import { PorFechaComponent } from './reportes/por-fecha/por-fecha.component';
import { ListActividadesComponent } from './formulacion/actividades/list-actividades/list-actividades.component';
import { TipoAgregacionComponent } from './parametrica/tipo-agregacion/tipo-agregacion/tipo-agregacion.component';
import { AcpComponent } from './formulacion/formulacion/acp.component';
import { GuiasComponent} from './ayuda/guia/guias.component';
import { EscalaComponent } from './parametrica/escala-salarial/escala.component';


@NgModule({
  imports: [
    SharedModule,
    PAGES_ROUTES,
    FormsModule,
    CommonModule,
    HttpClientModule,
    //RouterModule.forRoot(appRoutes),
    DxButtonModule,
    DxDataGridModule,
    DxTemplateModule,
    DxPopupModule,
    DxSelectBoxModule,
    DxCheckBoxModule,
    DxChartModule,
    DxTreeListModule,
    DxScrollViewModule,
    DxNumberBoxModule,
    DxDateBoxModule,
    DxPieChartModule,
    DxTextBoxModule,
    DxTabPanelModule,
    DxTreeViewModule,
    DxDropDownBoxModule,
    DxToastModule,
    DxTooltipModule,
    DxTextBoxModule,
    DxTagBoxModule    
  ],
  declarations: [
    InicioComponent,
    DashboardComponent,
    PagesComponent,

    AuthComponent,
    FilterPipe,
    NumberFormatPipe,
    CajaComponent,
    ListFormulacionComponent,
    ListTareaComponent,
    UnidadOrganizacionalComponent,
    FuenteComponent,
    OrganismoComponent,
    CategoriaProgramaticaComponent,
    ProgramaComponent,
    UnidadMedidaComponent,
    PartidaComponent,
    IntervencionComponent,
    PoaGestionComponent,    
    OnlyNumberDirective,    
    ListIntervencionComponent,
    FusComponent,
    InicioEjecucionComponent,
    ListFusComponent,
    PlaFusComponent,
    TraspasoDeComponent,
    TraspasoAlComponent,
    LiberacionComponent,
    AsignacionComponent,
    TraspasosAprobarComponent,
    TraspasosFinancieraComponent,
    TraspasosJuridicaComponent,
    AuthComponent,
    ConfigGestionComponent,
    FusJefaturaComponent,
    PptoFusComponent,
    RptGeneralComponent,
    SegFusComponent,
    SegFusUEComponent,
    UserConfigComponent,
    RptEjecucionFusComponent,
    RptSegTraspasoComponent,
    UsersComponent,
    SisinComponent,
    DireccionAdministrativaComponent,
    SolicitudModificacionComponent,
    SeguimientoInicioComponent,
    SeguimientoComponent,
    InicioFormulacionComponent,
    InicioInicioComponent,
    ListaReportadosComponent,
    MesActivoComponent,
    ConsolidadoComponent,
    UnidadEjecutoraSigepComponent,
    RevisionOperacionOdsComponent,
    RevisionAcpOdsComponent,
    OdsComponent,
    PsdiComponent,
    RevisionInicioComponent,
    FormulacionComponent,
    FusContabilidadComponent,
    RolesComponent,
    VistaComponent,
    ManualComponent,
    AprobarSolicitudComponent,
    FusJueUfinComponent,    
    FusPagoComponent, InicioReversionComponent, RptFormulacionComponent, SeguimientoPdesComponent, IndicadoresComponent, SeguimientoPsdiComponent, SeguimientoPeiComponent, AvisosComponent, GruposComponent,
    PacSolicitudInicioComponent, PacSolicitudComponent, PacSolicitudAprobarComponent, AprobarSolicitudJueComponent, FusManualComponent, FusInicioComponent, FusesComponent, TraspasosComponent, ModificacionFisicaComponent, ObservacionComponent, DescripcionReporteComponent, PlantillasComponent, PermisoComponent, UserPerfilComponent, PorFechaComponent, ListActividadesComponent, TipoAgregacionComponent,
    AcpComponent, GuiasComponent, EscalaComponent
  ],
  exports: [
    InicioComponent,
    DashboardComponent,
    PagesComponent
  ],
  providers: [
    AuthGuard,
    AuthenticationService
  ],
})
export class PagesModule { }
